/**
 * Mirrors packages/amgsicbo_v2/lib/presentation/rive/rive_inputs.dart.
 */

export const MainInputs = {
  stateMachine: 'animationManager',
  girlAnim: 'GirlAnimSeltion', // (sic — typo preserved from .riv)
  trigGirlAnim: 'GirlAnimplay',
  hoverNumber: 'HoverNumber',
  isWin: 'isWin',
  startTextAnim: 'startTextAnim',
  trigBGMusic: 'BGMusicOnOff',
  trigSound: 'SoundOnOff',
  isSound: 'isSound',
} as const;

export const TopLayerInputs = {
  stateMachine: 'animationManager',
  betPanelNumber: 'BetPanelNumber',
  betPanelTrigger: 'BetPanelTrigger',
  diceBowlPosition: 'DiceBowlPosition',
  diceBowlPlay: 'DiceBowlPlay',
  diceNum1: 'DiceNum1',
  diceNum2: 'DiceNum2',
  diceNum3: 'DiceNum3',
  trigSound: 'SoundOnOff',
  trigBGMusic: 'BGMusicOnOff',
  isSound: 'isSound',
} as const;

export const BettingInputs = {
  stateMachine: 'animationManager',
  isMouse: 'isMouse',
  isSound: 'isSound',
} as const;

export const TextInputs = {
  balance: 'txtRCoinAmount',
  username: 'txtUsername',
  playerWinLose: 'txtPlayerWinLose',
} as const;

export const BetPanelState = {
  startBet: 1,
  noMoreBet: 2,
} as const;

export const DiceBowlState = {
  start: 1,
  reveal: 2,
} as const;

export const RiveEventNames = {
  clickChips: 'evtClickChips',
  settings: 'evtSettings',
  sound: 'evtSound',
  bgm: 'evtBGM',
  clearClick: 'evtClearClick',
  buttonPlayClick: 'evtButtonPlayClick',
  placeBetClick: 'placeBetClick',
  diceBowlEnd: 'DiceBowlEnd',
  uiButtonClick: 'UIButtonClick',
  resultStop: 'evtResultStop',
  allControllersReady: 'allControllersReady',
} as const;
